/* eslint-disable no-shadow */
import Vue from 'vue'
import Vuex from 'vuex'
import user from './UserStore'
import activities from './ActivitiesStore'
import exam from './ExamStore'
import video from './VideoStore'
import content from './ContentStore'
import { version } from '../../package.json'

const storeKey = process.env.VUE_APP_LOCALSTORAGE_KEY

Vue.use(Vuex)
export const showModal = 'showModal'
export const hideModal = 'hideModal'
export const setPending = 'setPending'
export const setRouteError = 'setRouteError'
export const INIT = 'INIT'

export const state = {
  modalVisible: false,
  modalComponent: null,
  modalTitle: '',
  modalProps: null,
  currentExam: null,
  routeError: null,
  pending: false,
  version: null
}

export const mutations = {
  [showModal](state, { component, title, props }) {
    state.modalVisible = true
    state.modalTitle = title
    state.modalComponent = component
    state.modalProps = props
  },
  [hideModal](state) {
    state.modalVisible = false
  },
  [setPending](state, { pendingState }) {
    state.pending = pendingState
  },
  [INIT](state) {
    // check if the store exists
    if (localStorage.getItem(storeKey)) {
      const store = JSON.parse(localStorage.getItem(storeKey))
      // Check the version stored against current. If different, don't
      // load the cached version
      if (store.version === version) {
        this.replaceState(Object.assign(state, store))
        window.console.log('state restored')
      } else {
        state.version = version
      }
    } else {
      state.version = version
    }
  },
  [setRouteError](state, value) {
    state.routeError = value
  }
}

const store = new Vuex.Store({
  state,
  modules: {
    user,
    activities,
    video,
    content,
    exam: {
      namespaced: true,
      /** AFAIK, this should be the same base for exams */
      state: () => ({
        base_media_url: null
      }),
      mutations: {
        UPDATE_MEDIA_URL(state, url) {
          state.base_media_url = url
        }
      },
      modules: {
        flanker: exam,
        go_no_go: exam,
        trails: exam,
        paired_association: exam,
        processing_speed: exam,
        image_pairs: exam
      },
      getters: {
        getAssessmentIdForExam: examStore => type => examStore[type]?.assessment_id
      }
    }
  },
  getters: {},
  mutations,
  actions: {
    setHttpError({ commit, dispatch }, response) {
      if (response) {
        commit(setRouteError, response.status)
        if (response.status === 401) {
          dispatch('user/logout')
        }
      } else {
        commit(setRouteError, null)
      }
    }
  }
})

export default store
